module.exports = __webpack_public_path__ + "static/semantic-tooltip-position-ad9f6fdf5935887d86aeeda41523f8bc.png";